import React, { useEffect, useState } from "react";
import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import am4themes_animated from "@amcharts/amcharts4/themes/animated";
import CustomDatePicker from "../../Common/CustomDatePicker";
import {
  RootBox,
  CategorySection,
  CategoryHeader,
  CategoryTitle,
  ScoreGrid,
  ScoreCell,
  ScoreCellTypography,
  TotalScoreTypography,
  TotalScoreValue,
  ChartContainer,
} from "./WheelOfLifeChart.styles";

am4core.useTheme(am4themes_animated);

const WheelOfLifeChart = ({
  chartData,
  setChartData,
  categories,
  categoryColors,
  date,
  setDate,
}) => {
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    const chart = am4core.create("chartdiv", am4charts.RadarChart);
    chart.hiddenState.properties.opacity = 0;
    chart.data = chartData;
    chart.padding(20, 20, 20, 20);
    chart.logo.disabled = true;

    const categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
    categoryAxis.dataFields.category = "label";
    categoryAxis.renderer.labels.template.location = 0.5;
    categoryAxis.renderer.labels.template.fontSize = 12;

    const valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
    valueAxis.min = 0;
    valueAxis.max = 10;
    valueAxis.renderer.labels.template.disabled = true;

    const series = chart.series.push(new am4charts.RadarColumnSeries());
    series.columns.template.tooltipText = "{label}: {valueY.value}";
    series.columns.template.width = am4core.percent(100);
    series.columns.template.strokeWidth = 0;
    series.columns.template.adapter.add("fill", (fill, target) =>
      target.dataItem ? target.dataItem.dataContext.color : fill
    );
    series.dataFields.categoryX = "label";
    series.dataFields.valueY = "value";

    return () => chart.dispose();
  }, [chartData]);

  const handleSetValue = (index, value) => {
    const newData = [...chartData];
    newData[index].value = value;
    setChartData(newData);
    setCurrentIndex((prev) => prev + 1);
  };

  const totalScore = chartData.reduce((acc, curr) => acc + curr.value, 0);
  const showCategoryStep = currentIndex < categories.length;

  return (
    <RootBox>
      {showCategoryStep ? (
        <CategorySection>
          <CategoryHeader direction="row" spacing={2}>
            <CategoryTitle variant="h5" gutterBottom>
              {categories[currentIndex].label}
            </CategoryTitle>
            <CustomDatePicker value={date} setValue={setDate} width="25%" />
          </CategoryHeader>

          <ScoreGrid>
            {[...Array(10).keys()].map((num) => {
              const value = num + 1;
              const isSelected = chartData[currentIndex]?.value === value;
              const categoryColor = categoryColors[currentIndex];
              return (
                <ScoreCell
                  key={num}
                  isSelected={isSelected}
                  categoryColor={categoryColor}
                  onClick={() => handleSetValue(currentIndex, value)}
                >
                  <ScoreCellTypography variant="body1" isSelected={isSelected}>
                    {value}
                  </ScoreCellTypography>
                </ScoreCell>
              );
            })}
          </ScoreGrid>
        </CategorySection>
      ) : (
        <TotalScoreTypography>
          Total Score:{" "}
          <TotalScoreValue component="span">{totalScore}</TotalScoreValue>
        </TotalScoreTypography>
      )}
      <ChartContainer id="chartdiv" />
    </RootBox>
  );
};

export default WheelOfLifeChart;
